import { parseUrl } from '@tinkoff/statist-page-data/browser';
import { resolvePageUrl, w } from '@tinkoff/statist-page-data';
import { isInIframe } from '../utils/browser';
export function getPageUrl() {
    var _a;
    var url;
    if (isInIframe()) {
        var iframeUrl = w.location.href;
        var iframeLocation = parseUrl(iframeUrl);
        url = (_a = iframeLocation.query.parent_url) !== null && _a !== void 0 ? _a : iframeUrl;
    }
    else {
        url = w.location.href;
    }
    var location = parseUrl(url);
    return resolvePageUrl(location);
}
//# sourceMappingURL=pageUrl.js.map